import { defineStore } from 'pinia'
import { ref } from 'vue'
import { LoggingService } from '@/services/logging.service'
import type { ToasterMessage } from '@/entities/toaster-message'

const loggingService = new LoggingService()

export const useNotificationStore = defineStore('notification', () => {
  // --- state
  const messages = ref<ToasterMessage[]>([])

  // --- actions
  async function addMessage(message: ToasterMessage) {
    const id = Date.now() + Math.random() * 10000
    messages.value.push({ ...message, id })

    if (message.type === 'error') {
      loggingService.postLog({
        logLevel: 'error',
        message: message.message
      }).catch(err => {
        const errorMessage: ToasterMessage = {
          message: `Error logging: ${err?.error?.statusCode} – ${err?.error?.message}`,
          type: 'error',
          values: null,
        }

        messages.value.unshift(errorMessage)
      })
    }
  }

  function deleteMessage(message: ToasterMessage & { id?: number}) {
    if (message.id === undefined) {
      const index = messages.value.findIndex(m => m === message)
      if (index !== -1) messages.value.splice(index, 1)
    } else {
      messages.value = messages.value.filter(m => m.id !== message.id)
    }
  }

  function deleteMessageById(id: number) {
    messages.value = messages.value.filter(m => m.id !== id)
  }

  return { messages, addMessage, deleteMessage, deleteMessageById }
})
